// import { CommonModule } from '@angular/common';
// import { Component } from '@angular/core';
// import { AngularFireDatabase } from '@angular/fire/compat/database';
// import { FormBuilder } from '@angular/forms';
// import { Router, ActivatedRoute, RouterLink, RouterModule, NavigationEnd } from '@angular/router';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { ToastrService } from 'ngx-toastr';
// import { OneSignal } from 'onesignal-ngx';
// import { debounceTime, Subject, takeUntil } from 'rxjs';
// import { AuthService } from 'src/app/services/auth.service';
// import { ClubService } from 'src/app/services/club.service';
// import { LaundryService } from 'src/app/services/laundry.service';
// import { RestaurantService } from 'src/app/services/restaurant.service';
// import { RoomService } from 'src/app/services/roomService-service';
// import { UserService } from 'src/app/services/user.service';
// import { environment } from 'src/environments/environments';

// declare var $: any;
// import Swal from "sweetalert2";
// @Component({
//   selector: 'app-site-headers',
//   standalone: true,
//   imports: [RouterModule, RouterLink, CommonModule],
//   templateUrl: './site-headers.component.html',
//   styleUrl: './site-headers.component.scss'
// })
// export class SiteHeadersComponent {
//   role_id: any;
//   apartmentName: any;
//   userType: string = '';
//   name: any;
//   username: any;
//   getNewOrdersCount: any
//   getNewRoomOrdersCount: any
//   getNewFoodOrdersCount: any;
//   getAdditionalOrdersCount: any;
//   restID: any;
//   wasDeliveryActive = false;
//   permissions: string[] = [];


//   activestatus: any = 1;
//   blockstatus: any;
//   loading: boolean = false;
//   submitted: boolean = false;
//   private destroy$ = new Subject<void>();
//   private processedOrderIds = new Set<string>(); 

//   constructor(
//     public router: Router,
//     private auth: AuthService,
//     private route: ActivatedRoute,
//     private user: UserService,
//     private formBuilder: FormBuilder,
//     private toastr: ToastrService,
//     private laundry: LaundryService,
//     private roomService: RoomService,
//     private food: RestaurantService,
//     private club: ClubService,
//     private db: AngularFireDatabase,
//     private oneSignal: OneSignal,
//     private spinner: NgxSpinnerService,
//   ) { }

//   ngOnInit() {
//     this.setUserData();
//     this.loadUserAccess();
//     this.loadActiveStatus();

//     // this.initOneSignal();
//     window.onload = () => {
//       console.log('✅ Window has fully loaded');
//     };
//     this.router.events.subscribe(event => {
//       if (event instanceof NavigationEnd) {
//         this.setUserData();
//       }
//     });
//     this.laundry.getNewDeliveryCount().subscribe((data) => {
//       this.getNewOrdersCount = data.data;
//     });
//     this.roomService.getNewRoomOrderCount().subscribe((data) => {
//       this.getNewRoomOrdersCount = data.data;
//     });

//     this.food.getNewDeliveryCount().subscribe((data) => {
//       this.getNewFoodOrdersCount = data.data;
//     });
//     this.roomService.getNewAdditionalOrderCount().subscribe((data) => {
//       this.getAdditionalOrdersCount = data.data;
//     });


//     this.firebase();

//   }

// //     firebase() {
// //     const restId = localStorage.getItem("_restId");
// //     const userType = localStorage.getItem("type") || localStorage.getItem("userType") || '';

// //     this.db.list("data").valueChanges().pipe(
// //       debounceTime(300)
// //     ).subscribe((data: any[]) => {
// //      console.log("5954yi9",data)

// //       const relevantItems = data?.filter((item: any) =>
// //         (item.restId === restId || item.childId === restId)
// //       );
// // console.log("relevantItems",relevantItems)
// //       const hasDeliveryStatus = relevantItems.some(
// //         (item: any) => item.orderStatus === "ordered" || item.orderStatus === "laundryDeliver"
// //       );

// //       const hasCancelledStatus = relevantItems.some(
// //         (item: any) =>
// //           item.orderStatus === "cancelled" || item.orderStatus === "rejected"
// //       );
// // console.log("hasCancelledStatus",hasCancelledStatus)


// //       if ((hasDeliveryStatus || hasCancelledStatus) && !this.wasDeliveryActive) {
// //         this.wasDeliveryActive = true;

// //         if (['apartment', 'laundry', 'restaurant'].includes(userType)) {
// //           setTimeout(() => {
// //           if (hasCancelledStatus) {
// //             this.playCancelSound();  
// //             console.log("Playing CANCEL sound");
// //           }
// //           else{
// //               this.playCustomSound();
// //           }
// //           }, 500);
// //         }

// //         if (userType === 'laundry') {
// //           this.laundry.getNewDeliveryCount().subscribe((data) => {
// //             this.getNewOrdersCount = data.data;
// //           });
// //         } else if (userType === 'apartment') {
// //           this.roomService.getNewRoomOrderCount().subscribe((data) => {
// //             this.getNewRoomOrdersCount = data.data;
// //           });
// //           this.roomService.getNewAdditionalOrderCount().subscribe((data) => {
// //             this.getAdditionalOrdersCount = data.data;
// //           });

// //         } else {
// //           this.food.getNewDeliveryCount().subscribe((data) => {
// //             this.getNewFoodOrdersCount = data.data;
// //           });
// //         }
// //         setTimeout(() => {
// //           window.location.reload();
// //         }, 5000); 

// //         //this.clearDatabase();

// //       } else if (!hasDeliveryStatus && this.wasDeliveryActive) {

// //         this.wasDeliveryActive = false;
// //         //this.clearDatabase();
// //       }
// //     });
// //   }


// //   firebase() {
// //     const restId = localStorage.getItem("_restId");
// //     // const userType = localStorage.getItem("type");
// //     const userType = localStorage.getItem("type") || localStorage.getItem("userType") || '';

// //     this.db.list("data").valueChanges().pipe(
// //       debounceTime(300)
// //     ).subscribe((data: any[]) => {
// //      console.log("5954yi9",data)

// //       const relevantItems = data?.filter((item: any) =>
// //         (item.restId === restId || item.childId === restId)
// //       );
// // console.log("relevantItems",relevantItems)
// //       const hasDeliveryStatus = relevantItems.some(
// //         (item: any) => item.orderStatus === "ordered" || item.orderStatus === "laundryDeliver"
// //       );

// //       const hasCancelledStatus = relevantItems.some(
// //         (item: any) =>
// //           item.orderStatus === "cancelled" || item.orderStatus === "rejected"
// //       );
// // console.log("hasCancelledStatus",hasCancelledStatus)


// //       if ((hasDeliveryStatus || hasCancelledStatus) && !this.wasDeliveryActive) {
// //         this.wasDeliveryActive = true;


// //         // ✅ Play sound for allowed user types
// //         // if (['apartment', 'laundry', 'restaurant'].includes(userType)) {
// //         //   this.playCustomSound();
// //         //   console.log("playing....")
// //         // }
// //         //  window.location.reload();
// //         if (['apartment', 'laundry', 'restaurant'].includes(userType)) {
// //           setTimeout(() => {
// //           if (hasCancelledStatus) {
// //             this.playCancelSound();  
// //             console.log("Playing CANCEL sound");
// //           }
// //           else{
// //               this.playCustomSound();
// //           }
// //           }, 500);
// //         }


// //         // =================================

// //         // const hasNewOrder = relevantItems.some((item: any) => item.orderStatus === "ordered");
// //         // const hasCancelledOrder = relevantItems.some((item: any) => item.orderStatus === "cancelled");

// //         // Swal.fire({
// //         //   title: hasNewOrder ? '📢 New Order Received!' : '⚠️ Order Cancelled!',
// //         //   text: hasNewOrder
// //         //     ? 'A new order has been placed. Do you want to view it now?'
// //         //     : 'An order has been cancelled. Do you want to view it now?',
// //         //   icon: hasNewOrder ? 'info' : 'warning',
// //         //   showCancelButton: true,
// //         //   confirmButtonText: 'View Now',
// //         //   cancelButtonText: 'Ignore',
// //         // }).then((result) => {
// //         //   if (result.isConfirmed) {
// //         //     if (hasNewOrder) {
// //         //       // ✅ Redirect to New Order pages
// //         //       if (userType === 'laundry') {
// //         //         this.router.navigate(['/new-order']);
// //         //       } else if (userType === 'apartment') {
// //         //         this.router.navigate(['/room-new-order']);
// //         //       } else if (userType === 'restaurant') {
// //         //         this.router.navigate(['/food-new-order']);
// //         //       }
// //         //     } else if (hasCancelledOrder) {
// //         //       // ✅ Redirect to Cancel Order pages
// //         //       if (userType === 'laundry') {
// //         //         this.router.navigate(['/order-cancel']);
// //         //       } else if (userType === 'apartment') {
// //         //         this.router.navigate(['/room-order-cancel']);
// //         //       } else if (userType === 'restaurant') {
// //         //         this.router.navigate(['/food-order-cancel']);
// //         //       }
// //         //     }
// //         //   }
// //         // });
// //         // =========================================================

// //         // ✅ Fetch order counts (based on userType)
// //         if (userType === 'laundry') {
// //           this.laundry.getNewDeliveryCount().subscribe((data) => {
// //             this.getNewOrdersCount = data.data;
// //           });
// //         } else if (userType === 'apartment') {
// //           this.roomService.getNewRoomOrderCount().subscribe((data) => {
// //             this.getNewRoomOrdersCount = data.data;
// //           });
// //           this.roomService.getNewAdditionalOrderCount().subscribe((data) => {
// //             this.getAdditionalOrdersCount = data.data;
// //           });

// //         } else {
// //           this.food.getNewDeliveryCount().subscribe((data) => {
// //             this.getNewFoodOrdersCount = data.data;
// //           });
// //         }
// //         setTimeout(() => {
// //           window.location.reload();
// //         }, 5000); // small delay to allow things like sound or count to complete

// //         // ✅ Clear Firebase DB
// //         this.clearDatabase();

// //       } else if (!hasDeliveryStatus && this.wasDeliveryActive) {
// //         // 🧹 Reset state and clear DB if delivery was active but now gone
// //         this.wasDeliveryActive = false;
// //         this.clearDatabase();
// //       }
// //     });
// //   }


//   ngOnDestroy() {
//     // ✅ Clean up all subscriptions
//     this.destroy$.next();
//     this.destroy$.complete();
//   }

//   // firebase() {
//   //   const restId = localStorage.getItem("_restId");
//   //   const userType = localStorage.getItem("type") || localStorage.getItem("userType") || '';

//   //   this.db.list("data").valueChanges().pipe(
//   //     debounceTime(300),
//   //     takeUntil(this.destroy$) // ✅ Auto-unsubscribe on destroy
//   //   ).subscribe((data: any[]) => {
//   //     console.log("Firebase data received:", data);

//   //     if (!data || data.length === 0) return;

//   //     const relevantItems = data?.filter((item: any) =>
//   //       item.restId === restId || item.childId === restId
//   //     );

//   //     if (!relevantItems.length) return;

//   //     const hasDeliveryStatus = relevantItems.some(
//   //       (item: any) => item.orderStatus === "ordered" || item.orderStatus === "laundryDeliver"
//   //     );

//   //     const hasCancelledStatus = relevantItems.some(
//   //       (item: any) => item.orderStatus === "cancelled" || item.orderStatus === "rejected"
//   //     );

//   //     if ((hasDeliveryStatus || hasCancelledStatus) && !this.wasDeliveryActive) {
//   //       this.wasDeliveryActive = true;

//   //       // Play sound
//   //       if (['apartment', 'laundry', 'restaurant'].includes(userType)) {
//   //         setTimeout(() => {
//   //           hasCancelledStatus ? this.playCancelSound() : this.playCustomSound();
//   //         }, 500);
//   //       }

//   //       // Update counts
//   //       this.refreshOrderCounts(userType);

//   //       // ✅ Clear Firebase FIRST, then reload — no more stale data loop
//   //       this.clearDatabase().then(() => {
//   //         setTimeout(() => {
//   //           this.wasDeliveryActive = false; // Reset before reload
//   //           window.location.reload();
//   //         }, 3000);
//   //       });

//   //     } else if (!hasDeliveryStatus && !hasCancelledStatus && this.wasDeliveryActive) {
//   //       this.wasDeliveryActive = false;
//   //     }
//   //   });
//   // }



// firebase() {
//   const restId = localStorage.getItem("_restId");
//   const userType = localStorage.getItem("type") || localStorage.getItem("userType") || '';

//   this.db.database.ref('data').on('value', (snapshot) => {
//     if (!snapshot.exists()) return; // ✅ Ignore empty/null snapshots

//     const rawData = snapshot.val();
//     console.log("🔥 Data received:", rawData);

//     // Convert object to array
//     const data: any[] = Object.values(rawData);

//     const relevantItems = data.filter((item: any) =>
//       item.restId === restId || item.childId === restId
//     );

//     if (!relevantItems.length) return;

//     const hasDeliveryStatus = relevantItems.some(
//       (item: any) => item.orderStatus === "ordered" || item.orderStatus === "laundryDeliver"
//     );

//     const hasCancelledStatus = relevantItems.some(
//       (item: any) => item.orderStatus === "cancelled" || item.orderStatus === "rejected"
//     );

//     if ((hasDeliveryStatus || hasCancelledStatus) && !this.wasDeliveryActive) {
//       this.wasDeliveryActive = true;

//       if (['apartment', 'laundry', 'restaurant'].includes(userType)) {
//         setTimeout(() => {
//           hasCancelledStatus ? this.playCancelSound() : this.playCustomSound();
//         }, 500);
//       }

//       this.refreshOrderCounts(userType);

//       setTimeout(() => {
//         window.location.reload();
//       }, 3000);
//     }
//   });
// }

//   // ✅ Return a Promise so we can await it
//   clearDatabase(): Promise<void> {
//     return this.db.database
//       .ref()
//       .remove()
//       .then(() => console.log("✅ Database cleared"))
//       .catch((error) => console.error("❌ Error clearing database:", error));
//   }

//   refreshOrderCounts(userType: string) {
//     if (userType === 'laundry') {
//       this.laundry.getNewDeliveryCount().subscribe(d => this.getNewOrdersCount = d.data);
//     } else if (userType === 'apartment') {
//       this.roomService.getNewRoomOrderCount().subscribe(d => this.getNewRoomOrdersCount = d.data);
//       this.roomService.getNewAdditionalOrderCount().subscribe(d => this.getAdditionalOrdersCount = d.data);
//     } else if (userType === 'restaurant') {
//       this.food.getNewDeliveryCount().subscribe(d => this.getNewFoodOrdersCount = d.data);
//     }
//   }


//   setUserData() {

//     const appName = `${environment.appName}`;
//     this.role_id = localStorage.getItem(appName + 'role_id');
//     this.username = localStorage.getItem( 'username');
//     this.userType = localStorage.getItem('userType') || '';

//     //this.username = localStorage.getItem(appName + 'username');
//     this.name = localStorage.getItem('name') || '';


//     this.apartmentName = this.name;
//   }

//   loadUserAccess() {
//     const perms = localStorage.getItem('user_permissions');
//     this.permissions = perms ? JSON.parse(perms) : [];

//     this.userType = localStorage.getItem('userType') || '';
//   }

//   hasPermission(key: string): boolean {
//     return this.permissions.includes(key);
//   }


//   playCustomSound() {
//     const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
//     const audioContext = new AudioContext();

//     // Ensure context is resumed
//     if (audioContext.state === 'suspended') {
//       audioContext.resume().then(() => {
//         console.log("🎵 Audio context resumed");
//       });
//     }

//     const soundUrl = "/assets/images/swiggy_new_order.mp3"; // Use absolute path for reliability

//     fetch(soundUrl)
//       .then(res => res.arrayBuffer())
//       .then(buffer => audioContext.decodeAudioData(buffer))
//       .then(decoded => {
//         const source = audioContext.createBufferSource();
//         source.buffer = decoded;
//         source.connect(audioContext.destination);
//         source.start();

//       })
//       .catch(err => console.error("🔇 Sound error:", err));
//   }

//     playCancelSound() {
//     const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
//     const audioContext = new AudioContext();

//     // Ensure context is resumed
//     if (audioContext.state === 'suspended') {
//       audioContext.resume().then(() => {
//         console.log("🎵 cancel!!!!!!!!!!!!!!");
//       });
//     }

//     const soundUrl = "/assets/images/cancel_order.mp3"; 

//     fetch(soundUrl)
//       .then(res => res.arrayBuffer())
//       .then(buffer => audioContext.decodeAudioData(buffer))
//       .then(decoded => {
//         const source = audioContext.createBufferSource();
//         source.buffer = decoded;
//         source.connect(audioContext.destination);
//         source.start();

//       })
//       .catch(err => console.error("🔇 Sound error:", err));
//   }



//   // clearDatabase() {
//   //   this.db.database
//   //     .ref()
//   //     .remove()
//   //     .then(() => {
//   //       console.log("Database cleared successfully.");
//   //     })
//   //     .catch((error) => {
//   //       console.error("Error clearing database:", error);
//   //     });
//   // }


//   // logout() {
//   //   var that = this;
//   //   Swal.fire({
//   //     title: 'Are You Sure You Want To Logout?',
//   //     icon: 'warning',
//   //     showCancelButton: true,
//   //     confirmButtonColor: '#3085d6',
//   //     cancelButtonColor: '#d33',
//   //     confirmButtonText: 'OK'
//   //   }).then((result) => {
//   //     if (window && 'OneSignal' in window) {
//   //       const OneSignal = (window as any).OneSignal;
//   //       OneSignal.removeExternalUserId();
//   //     }
//   //     if (result.isConfirmed) {
//   //       this.oneSignal.removeExternalUserId();
//   //       this.oneSignal.setSubscription(false);
//   //       that.auth.logout();
//   //       that.router.navigate(['/login']);
//   //     } else if (result.isDenied) {
//   //       Swal.fire('Changes are not saved', '', 'info')
//   //     }
//   //   })
//   // }



//   // logout() {
//   //   Swal.fire({
//   //     title: 'Are You Sure You Want To Logout?',
//   //     icon: 'warning',
//   //     showCancelButton: true,
//   //     confirmButtonColor: '#3085d6',
//   //     cancelButtonColor: '#d33',
//   //     confirmButtonText: 'OK'
//   //   }).then((result) => {

//   //     if (result.isConfirmed) {

//   //       // ✅ ONLY remove user mapping
//   //       this.oneSignal.removeExternalUserId();

//   //       // ❌ DO NOT unsubscribe
//   //       // ❌ DO NOT access window.OneSignal

//   //       // clear app session
//   //       this.auth.logout();

//   //       this.router.navigate(['/login']);
//   //     }

//   //   });
//   // }
//   logout() {
//     Swal.fire({
//       title: 'Are You Sure You Want To Logout?',
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'OK'
//     }).then((result) => {

//       if (!result.isConfirmed) return;

//       const userId = localStorage.getItem('_restId');
//       const playerId = localStorage.getItem('player_id');
//       const userType = localStorage.getItem('type');

//       // 1️⃣ Call backend delete API
//       if (userId && playerId && userType) {
//         this.user.deleteOneSignal(userId, playerId, userType).subscribe({
//           next: () => console.log('✅ OneSignal deleted from backend'),
//           error: err => console.error('❌ Delete OneSignal failed', err)
//         });
//       }

//       // 2️⃣ Remove OneSignal user mapping
//       this.oneSignal.removeExternalUserId();
//       this.oneSignal.deleteTag('user_type');

//       // 3️⃣ Clear session
//       this.auth.logout();
//       localStorage.clear();
//       sessionStorage.clear();

//       // 4️⃣ Navigate
//       this.router.navigate(['/login']);
//     });
//   }

//   customerUrl() {
//     if (this.router.url.includes("/customer")) {
//       return true
//     } else if (this.router.url.includes("/add-customer")) {
//       return true
//     } else if (this.router.url.includes("/restaurant-details")) {
//       return true
//     } else {
//       return false
//     }
//   }
//   RoomUrl() {
//     if (this.router.url.includes("/room-service")) {
//       return true
//     } else if (this.router.url.includes("/room-service/add-category")) {
//       return true
//     } else if (this.router.url.includes("/room-service/room-item")) {
//       return true
//     } else if (this.router.url.includes("/room-service/add-subcategory")) {
//       return true
//     } else {
//       return false
//     }
//   }
//   LaundryUrl() {
//     if (this.router.url.includes("/laundry")) {
//       return true
//     } else if (this.router.url.includes("/laundry/add-category")) {
//       return true;
//     } else if (this.router.url.includes("/laundry/subcategory")) {
//       return true;
//     } else if (this.router.url.includes("/laundry/add-subcategory")) {
//       return true;
//     } else if (this.router.url.includes("/laundry/item")) {
//       return true;
//     } else if (this.router.url.includes("/laundry/add-item")) {
//       return true;
//     } else {
//       return false
//     }
//   }

//   RestaurantUrl() {
//     if (this.router.url.includes("/restaurants")) {
//       return true
//     } else {
//       return false
//     }
//   }
//   MenumanagementUrl() {
//     if (this.router.url.includes("/menu-management/variant")) {
//       return true
//     } else if (this.router.url.includes("/menu-management/add-variant")) {
//       return true;
//     } if (this.router.url.includes("/menu-management/category")) {
//       return true
//     } else if (this.router.url.includes("/menu-management/add-category")) {
//       return true;
//     } if (this.router.url.includes("/menu-management/addons")) {
//       return true
//     } else if (this.router.url.includes("/menu-management/add-addons")) {
//       return true;
//     } else if (this.router.url.includes("/menu-management/view-addons")) {
//       return true;
//     } if (this.router.url.includes("/menu-management/food-item")) {
//       return true
//     } else if (this.router.url.includes("/menu-management/add-item")) {
//       return true;
//     } else if (this.router.url.includes("/menu-management/view-item")) {
//       return true;
//     }
//     else {
//       return false
//     }
//   }
//   RoomOrderActiveurl() {
//     if (this.router.url.includes("/room-new-order")) {
//       return true;
//     } else if (this.router.url.includes("/room-delivery-order")) {
//       return true;
//     } else if (this.router.url.includes("/room-order-cancel")) {
//       return true;
//     } else if (this.router.url.includes("/room-order-reject")) {
//       return true;
//     } else if (this.router.url.includes("/room-accept-order")) {
//       return true;
//     }
//     else {
//       return false
//     }
//   }
//   AdditionalOrderActiveurl() {
//     if (this.router.url.includes("/additional-new-order")) {
//       return true;
//     } else if (this.router.url.includes("/additional-order-accepted")) {
//       return true;
//     } else if (this.router.url.includes("/additional-order-delivery")) {
//       return true;
//     } else if (this.router.url.includes("/additional-order-cancelled")) {
//       return true;
//     } else if (this.router.url.includes("/additional-order-rejected")) {
//       return true;
//     }
//     else {
//       return false
//     }
//   }

//   deliveryActiveurl() {
//     if (this.router.url.includes("/new-order")) {
//       return true;
//     } else if (this.router.url.includes("/order-delivery")) {
//       return true;
//     } else if (this.router.url.includes("/order-cancel")) {
//       return true;
//     } else if (this.router.url.includes("/order-reject")) {
//       return true;
//     } else if (this.router.url.includes("/order-accepted")) {
//       return true;
//     } else if (this.router.url.includes("/order-pickup")) {
//       return true;
//     }
//     else {
//       return false
//     }
//   }
//   StaffUrl() {
//     if (this.router.url.includes("/laundry-staff")) {
//       return true;
//     } else if (this.router.url.includes("/add-laundry-staff")) {
//       return true;
//     }
//     else {
//       return false
//     }
//   }
//   ApartmentStaffUrl() {
//     if (this.router.url.includes("/apartment-staff")) {
//       return true;
//     } else if (this.router.url.includes("/add-apartment-staff")) {
//       return true;
//     }
//     else {
//       return false
//     }
//   }
//   restaurantStaffUrl() {
//     if (this.router.url.includes("/restaurant-staff")) {
//       return true;
//     } else if (this.router.url.includes("/add-restaurant-staff")) {
//       return true;
//     }
//     else {
//       return false
//     }
//   }

//   FoodorderActiveurl() {
//     if (this.router.url.includes("/food-new-order")) {
//       return true;
//     } else if (this.router.url.includes("/food-order-delivery")) {
//       return true;
//     } else if (this.router.url.includes("/food-order-cancel")) {
//       return true;
//     } else if (this.router.url.includes("/food-order-reject")) {
//       return true;
//     } else if (this.router.url.includes("/food-order-accepted")) {
//       return true;
//     } else if (this.router.url.includes("/food-order-pickup")) {
//       return true;
//     }
//     else {
//       return false
//     }
//   }
//   //  initOneSignal() {
//   //     this.oneSignal.init({
//   //       appId: environment.OneSignalAppId,
//   //       autoRegister: false,
//   //       notifyButton: { enable: true },
//   //     });

//   //     this.oneSignal.showSlidedownPrompt();

//   //     this.oneSignal.isPushNotificationsEnabled().then((enabled) => {
//   //       if (!enabled) {
//   //         this.oneSignal.registerForPushNotifications().then(() => {
//   //           this.setExternalUserIdIfAvailable();
//   //         });
//   //       } else {
//   //         this.setExternalUserIdIfAvailable();
//   //       }
//   //     });

//   //     this.oneSignal.on('notificationDisplay', (event: any) => {
//   //       console.log("OneSignal Notification:", event);
//   //     });

//   //     // ✅ Fetch player_id and call your API
//   //     this.oneSignal.getUserId().then((playerId) => {
//   //       if (playerId) {
//   //         localStorage.setItem("player_id", playerId);

//   //         const userId = localStorage.getItem("_restId");
//   //         const userType = localStorage.getItem("type");

//   //         if (userId && userType) {
//   //           this.user.createOneSignal(userId, playerId, userType).subscribe({
//   //             next: (res) => {
//   //               console.log("✅ OneSignal player_id linked to user:", res);
//   //             },
//   //             error: (err) => {
//   //               console.error("❌ OneSignal API error:", err);
//   //             }
//   //           });
//   //         }
//   //       }
//   //     });
//   //   }

//   // initOneSignal() {
//   //   this.oneSignal.init({
//   //     appId: environment.OneSignalAppId,
//   //     autoRegister: true,
//   //     notifyButton: { enable: true, displayPredicate: () => true },
//   //     autoResubscribe: true,
//   //   });

//   //   this.oneSignal.showSlidedownPrompt();

//   //   this.oneSignal.isPushNotificationsEnabled().then((enabled) => {
//   //     if (!enabled) {
//   //       this.oneSignal.registerForPushNotifications().then(() => {
//   //         this.setExternalUserIdIfAvailable();
//   //       });
//   //     } else {
//   //       this.setExternalUserIdIfAvailable();
//   //     }
//   //   });

//   //   this.oneSignal.on('notificationDisplay', (event: any) => {
//   //     console.log("OneSignal Notification:", event);
//   //   });

//   //   // ✅ Fetch player_id and call your API
//   //   this.oneSignal.getUserId().then((playerId) => {
//   //     if (playerId) {
//   //       localStorage.setItem("player_id", playerId);

//   //       const userId = localStorage.getItem("_restId");
//   //       const userType = localStorage.getItem("type");

//   //       if (userId && userType) {
//   //         this.user.createOneSignal(userId, playerId, userType).subscribe({
//   //           next: (res) => {
//   //             console.log("✅ OneSignal player_id linked to user:", res);
//   //           },
//   //           error: (err) => {
//   //             console.error("❌ OneSignal API error:", err);
//   //           }
//   //         });
//   //       }
//   //     }
//   //   });
//   // }

//   setExternalUserIdIfAvailable() {
//     const userId = localStorage.getItem("_restId");
//     const userType = localStorage.getItem("type");

//     if (userId) {
//       this.oneSignal.setExternalUserId(userId);
//     }

//     if (userType) {
//       this.oneSignal.sendTag("user_type", userType);
//     }
//   }


//   statuschange1(event: any, type: string) {
//     console.log(`Status changed for ${type} → ${this.activestatus ? 'Active' : 'Inactive'}`);

//   }
//   statuschange(e: any, type: string) {
//     const newStatus = e.target.checked ? 1 : 0;
//     this.blockstatus = newStatus === 1 ? "Active" : "Inactive";

//     Swal.fire({
//       title: `Are You Sure You Want To ${this.blockstatus} This ${type}?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "OK",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         this.loading = true;

//         let apiCall;
//         if (type === "apartment") {
//           apiCall = this.roomService.apartmentStatusChange(newStatus);
//         } else if (type === "laundry") {
//           apiCall = this.laundry.laundryStatusChange(newStatus);
//         } else if (type === "restaurant") {
//           apiCall = this.food.foodstatusChange(newStatus);
//         } else if (type === "club") {
//           apiCall = this.club.clubstatusChange(newStatus);
//         }

//         apiCall.subscribe({
//           next: (data) => {
//             this.loading = false;
//             if (data.status.code == 200) {
//               this.toastr.success(data.status.message);
//               this.activestatus = newStatus;
//             } else {
//               this.toastr.error(data.status.message);
//               e.target.checked = !e.target.checked;
//             }
//           },
//           error: (error) => {
//             this.loading = false;
//             this.toastr.error(error.status && error.status.message);
//             e.target.checked = !e.target.checked;
//           },
//         });
//       } else {
//         e.target.checked = !e.target.checked;
//       }
//     });
//   }

//   loadActiveStatus() {
//     let apiCall: any;
//     const status = this.activestatus; // 0 or 1

//     if (this.userType === 'apartment') {
//       apiCall = this.user.getApartmentStatus();
//     }
//     else if (this.userType === 'laundry') {
//       apiCall = this.user.getLaundryStatus();
//     }
//     else if (this.userType === 'restaurant') {
//       apiCall = this.user.getRestaurantStatus();
//     }
//     else if (this.userType === 'club') {
//       apiCall = this.club.getClubStatus();
//     }

//     if (!apiCall) return;

//     apiCall.subscribe({
//       next: (res: any) => {
//         this.activestatus = Number(res.data.openStatus);
//       },
//       error: () => {
//         this.activestatus = 0;
//       }
//     });
//   }

// }
import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, NgZone, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { Router, RouterLink, RouterModule, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { OneSignal } from 'onesignal-ngx';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ClubService } from 'src/app/services/club.service';
import { LaundryService } from 'src/app/services/laundry.service';
import { OrderRefreshService } from 'src/app/services/order-refresh.service';
import { RestaurantService } from 'src/app/services/restaurant.service';
import { RoomService } from 'src/app/services/roomService-service';
import { UserService } from 'src/app/services/user.service';
import { ApartmentService } from 'src/app/services/apartment.service';
import { SosAlertService } from 'src/app/services/sos-alert.service';
import { EmergencyNotificationService } from 'src/app/services/emergency.service';
import { environment } from 'src/environments/environments';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-site-headers',
  standalone: true,
  imports: [RouterModule, RouterLink, CommonModule],
  templateUrl: './site-headers.component.html',
  styleUrl: './site-headers.component.scss'
})
export class SiteHeadersComponent implements OnInit, OnDestroy { // ✅ Implement interfaces
  role_id: any;
  apartmentName: any;
  userType: string = '';
  isStaff: boolean = false;
  apartmentType: string = '';
  isRoomServiceEnabled: boolean = true;
  isResidentialServiceEnabled: boolean = true;
  name: any;
  username: any;
  getNewOrdersCount: any;
  getNewRoomOrdersCount: any;
  getNewFoodOrdersCount: any;
  getNewResidentialOrdersCount: any;
  getAdditionalOrdersCount: any;
  getNewBookingsCount: any;
  wasDeliveryActive = false;
  permissions: string[] = [];
  activestatus: any = 1;
  blockstatus: any;
  loading: boolean = false;
  showApartmentSettingsDropdown = false;
  showPropertiesDropdown = false;
  showLogsDropdown = false;
  showRestaurantReportsDropdown = false;
  showRestaurantFinanceDropdown = false;
  showLaundryReportsDropdown = false;
  showLaundryFinanceDropdown = false;
  showClubPricingDropdown = false;
  showEmergencyDropdown = false;

  /* Sidebar submenus open on click, not hover. Every flag lives here so one
     open group can close the others and a document click can close them all. */
  private readonly dropdownKeys = [
    'showPropertiesDropdown',
    'showApartmentSettingsDropdown',
    'showLogsDropdown',
    'showRestaurantReportsDropdown',
    'showRestaurantFinanceDropdown',
    'showLaundryReportsDropdown',
    'showLaundryFinanceDropdown',
    'showClubPricingDropdown',
    'showEmergencyDropdown',
  ];

  /* Child routes per group, so the group containing the current page can be
     shown expanded.

     This is needed because <app-site-headers> is embedded in each of the ~124
     page templates rather than living in a persistent shell — every navigation
     destroys and rebuilds the header, wiping any in-memory "which group is open"
     flag. Deriving it from the URL survives that, and also means a deep link or
     refresh lands with the right group already open. */
  private readonly dropdownRoutes: Record<string, string[]> = {
    showPropertiesDropdown: ['/apartment-properties', '/apartment-settings'],
    showApartmentSettingsDropdown: [
      '/reports-apartment',
      '/reports-residential',
      '/apartment-notification',
      '/audit-logs',
    ],
    showLogsDropdown: [
      '/room-community-notice',
      '/digital-logs',
      '/gate-visitor',
      '/gate-delivery',
      '/gate-household-worker',
      '/gate-staff-logs',
      '/gate-staff-attendance',
    ],
    showEmergencyDropdown: [
      '/emergency-notification',
      '/floor-mapping',
      '/active-alert',
      '/alert-history',
      '/alert-response',
      '/alert-report',
      '/saved-alert',
    ],
    showLaundryFinanceDropdown: ['/laundry-settlement', '/cash-settlement'],
    showRestaurantFinanceDropdown: ['/restaurant-settlement', '/food-cash-settlement'],
    showClubPricingDropdown: ['/club/pricing', '/club/table-type'],
  };

  /* Expands the group that owns the current route. Called on init and after each
     navigation, so picking a child leaves its group open. */
  syncDropdownToRoute(): void {
    const url = (this.router.url || '').split('?')[0];
    Object.entries(this.dropdownRoutes).forEach(([key, routes]) => {
      if (routes.some((r) => url === r || url.startsWith(r + '/'))) {
        (this as any)[key] = true;
      }
    });
  }

  /* The click must not reach the document handler below, or the menu would
     close again in the same tick. */
  toggleDropdown(key: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    const wasOpen = (this as any)[key];
    this.closeAllDropdowns();
    (this as any)[key] = !wasOpen;
  }

  closeAllDropdowns(): void {
    this.dropdownKeys.forEach((k) => ((this as any)[k] = false));
  }

  /* Tablet / small-screen navigation.
     Below 992px the sidebar is off-canvas. It used to be revealed only by
     :hover / :focus-within, which a touch tablet cannot do — the whole menu was
     unreachable on an iPad. This drives an explicit toggle instead. */
  sidebarOpen = false;

  toggleSidebar(event: Event): void {
    event.preventDefault();
    event.stopPropagation();   // don't let onDocumentClick close it immediately
    this.sidebarOpen = !this.sidebarOpen;
  }

  closeSidebar(): void {
    this.sidebarOpen = false;
  }

  /* An outside click does NOT collapse an expanded submenu.

     The expanded group is how you can see which section you are in, so it stays
     open while you work on the page. The only thing that collapses it is opening
     a different group — toggleDropdown() calls closeAllDropdowns() first, so at
     most one is ever expanded — or clicking its own header again.

     This handler is therefore only about the tablet off-canvas drawer: below
     992px the sidebar sits over the page, so a tap outside it has to dismiss it,
     otherwise the drawer covers the page you just navigated to. */
  @HostListener('document:click')
  onDocumentClick(): void {
    this.closeSidebar();
  }

  /* Esc closes, for keyboard users. */
  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeAllDropdowns();
    this.closeSidebar();
  }
  showNotifPanel = false;
  isSubscribed = false;
  notifLoading = false;
  notifications: any[] = [];
  notifPage = 1;
  notifHasNext = false;
  totalCount: any
  code: any;


  private destroy$ = new Subject<void>();
  private firebaseListener: any; //  Store reference to detach listener later

  // Resident SOS: full-screen siren, then it flies into the header (state in SosAlertService)
  @ViewChild('sosSiren') sosSiren?: ElementRef<HTMLElement>;
  @ViewChild('sosDock') sosDock?: ElementRef<HTMLElement>;
  sosFlying = false;
  private sosTimer: any;
  private sirenAudio: AudioContext | null = null;
  private routerSub!: Subscription; // Store router subscription

  constructor(
    public router: Router,
    private auth: AuthService,
    private user: UserService,
    private toastr: ToastrService,
    private laundry: LaundryService,
    private roomService: RoomService,
    private food: RestaurantService,
    private club: ClubService,
    private apartmentService: ApartmentService,
    private db: AngularFireDatabase,
    private afMessaging: AngularFireMessaging,
    private oneSignal: OneSignal,
    private spinner: NgxSpinnerService,
    private orderRefresh: OrderRefreshService,
    private ngZone: NgZone,
    public sosAlert: SosAlertService,
    private emergencyService: EmergencyNotificationService
  ) { }

  ngOnInit() {
    this.setUserData();
    this.loadUserAccess();
    this.loadActiveStatus();
    this.loadNotifications();
    /* Expand the group that owns this page, so selecting a child route leaves its
       dropdown open (the header is rebuilt on every navigation). */
    this.syncDropdownToRoute();

    //  Store subscription so it can be cleaned up
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setUserData();
        this.syncDropdownToRoute();
      }
    });

    this.refreshOrderCounts(this.userType);
    this.firebase();

    // Docked SOS siren: shown while the apartment has pending SOS
    if (this.canSeeSos) {
      this.loadSosCount();
      this.sosAlert.refreshCount$.pipe(takeUntil(this.destroy$)).subscribe(() => this.loadSosCount());
    }
  }

  ngOnDestroy() {
    // ✅ Clean up Firebase native listener
    if (this.firebaseListener) {
      this.db.database.ref('data').off('value', this.firebaseListener);
    }

    // ✅ Clean up router subscription
    this.routerSub?.unsubscribe();

    // Leaving the page mid-alert: the new header shows the siren docked
    clearTimeout(this.sosTimer);
    this.stopSiren();
    this.sosAlert.collapse();

    // ✅ Clean up any RxJS subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }

  firebase() {
    const restId = localStorage.getItem('_restId');
    const userType = localStorage.getItem('type') || localStorage.getItem('userType') || '';
    const currentEnv = environment.env;
    //  Store listener reference for cleanup in ngOnDestroy
    this.firebaseListener = this.db.database.ref('data').on('value', (snapshot) => {
      this.ngZone.run(() => {
        if (!snapshot.exists()) return;

        const rawData = snapshot.val();
        const data: any[] = Object.values(rawData);
        console.log("firebase data", data)

        const envMatched = data.filter((item: any) => !item.env || item.env === currentEnv);
        if (!envMatched.length) return;

        this.handleSos(envMatched);

        const relevantItems = data.filter((item: any) =>
          item.restId === restId || item.childId === restId
        );

        if (!relevantItems.length) return;

        const hasDeliveryStatus = relevantItems.some(
          (item: any) => item.orderStatus === 'ordered'
        );

        const hasCancelledStatus = relevantItems.some(
          (item: any) => item.orderStatus === 'cancelled' || item.orderStatus === 'rejected'
        );

        const hasAcceptStatus = relevantItems.some(
          (item: any) => item.orderStatus === 'accept' || item.orderStatus === 'accept2' || item.orderStatus === 'delivered' || item.orderStatus === 'laundryDeliver' || item.orderStatus === 'approved' || item.orderStatus === 'paid' || item.orderStatus === "cod_requested" || item.orderStatus === "re_estimate_required" || item.orderStatus === 'accepted' || item.orderStatus === 'picked_up' || item.orderStatus === 'inspection_scheduled'
            || item.orderStatus === 'estimate_pending' || item.orderStatus === 'completed' || item.orderStatus === 'technician_accepted' || item.orderStatus === 'technician_declined' || item.orderStatus === 'work_in_progress' || item.orderStatus === 'cod_payment_pending'
        );

        if ((hasDeliveryStatus || hasCancelledStatus || hasAcceptStatus) && !this.wasDeliveryActive) {
          this.wasDeliveryActive = true;
          if (['apartment', 'laundry', 'restaurant', 'RESIDENTIAL_ROOM_SERVICE', 'club'].includes(userType)) {
            if (hasCancelledStatus) {
              this.playCancelSound();
            } else if (hasDeliveryStatus) {
              this.playCustomSound();
            }
          }

          if (hasDeliveryStatus || hasCancelledStatus) {
            this.notifications = [];
            this.loadNotifications();
          }

          this.refreshOrderCounts(userType);

          this.clearDatabase().then(() => {
            this.wasDeliveryActive = false;

            if (this.isOnOrderPage(userType)) {
              console.log("refreshing the page")
              this.orderRefresh.triggerRefresh();
            }
          });
        }
      });
    });
  }

  // Same people who see SOS History in the sidebar
  get canSeeSos(): boolean {
    return this.hasPermission('sos-history') || (this.userType === 'apartment' && !this.isStaff);
  }

  /* SOS items: { alert: 'sos_status', type: 'SOS', sosId, status: 'PENDING', childId (apartment id), env } — no restId,
     so they skip the order handling below. A new PENDING sosId sounds the siren full-screen. */
  private handleSos(items: any[]) {
    if (!this.canSeeSos) return;
    // Only this apartment's SOS: childId is the apartment id (_restId for an apartment admin)
    const apartmentId = localStorage.getItem('_restId');
    const sos = items.filter((item: any) => item.type === 'SOS' && item.sosId && item.childId === apartmentId);
    if (!sos.length) return;
    const isPending = (item: any) => String(item.status || '').toUpperCase() === 'PENDING';
    this.sosAlert.resolve(sos.filter((item) => !isPending(item)).map((item) => item.sosId));
    if (this.sosAlert.add(sos.filter(isPending).map((item) => item.sosId))) {
      this.loadSosCount();
      this.playSiren();
      clearTimeout(this.sosTimer);
      this.sosTimer = setTimeout(() => this.minimiseSos(), 8000);
    }
  }

  loadSosCount() {
    this.emergencyService.getSosPendingCount().subscribe({
      next: data => {
        if (data.status.code === 0 || data.status.code === 200 || data.status.code === 201) {
          // data: { count }
          this.sosAlert.pendingCount$.next(Number(data.data?.count) || 0);
        }
      },
      error: err => {
        this.spinner.hide();
        this.toastr.error(err?.status?.message || 'Something went wrong');
      }
    });
  }

  // Shrinks the siren into its spot in the header, then shows it docked there
  minimiseSos() {
    clearTimeout(this.sosTimer);
    this.stopSiren();
    const siren = this.sosSiren?.nativeElement;
    const dock = this.sosDock?.nativeElement;
    if (!siren || !dock || this.sosFlying) {
      this.sosAlert.collapse();
      return;
    }
    const from = siren.getBoundingClientRect();
    const to = dock.getBoundingClientRect();
    const dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    const dy = (to.top + to.height / 2) - (from.top + from.height / 2);
    siren.style.transform = `translate(${dx}px, ${dy}px) scale(${to.width / from.width})`;
    this.sosFlying = true;
    setTimeout(() => {
      this.sosFlying = false;
      this.sosAlert.collapse();
    }, 700);
  }

  // Overlay "View SOS" or the docked siren
  openSosHistory() {
    clearTimeout(this.sosTimer);
    this.stopSiren();
    this.sosAlert.acknowledge();
    this.router.navigate(['/sos-history']);
  }

  // emergency.mp3 on a loop while the full-screen siren is up; stopSiren() ends it
  private playSiren() {
    this.stopSiren();
    try {
      const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
      const ctx: AudioContext = new AudioContext();
      this.sirenAudio = ctx;
      if (ctx.state === 'suspended') {
        ctx.resume();
      }

      fetch('/assets/images/emergency.mp3')
        .then(res => res.arrayBuffer())
        .then(buffer => ctx.decodeAudioData(buffer))
        .then(decoded => {
          // Minimised / closed while the file was still loading
          if (this.sirenAudio !== ctx) return;
          const source = ctx.createBufferSource();
          source.buffer = decoded;
          source.loop = true;
          source.connect(ctx.destination);
          source.start();
        })
        .catch(err => console.error('🔇 Siren error:', err));
    } catch (err) {
      console.error('🔇 Siren error:', err);
    }
  }

  private stopSiren() {
    this.sirenAudio?.close().catch(() => { });
    this.sirenAudio = null;
  }

  refreshOrderCounts(userType: string) {
    if (userType === 'laundry') {
      this.laundry.getNewDeliveryCount().subscribe(d => this.getNewOrdersCount = d.data);
    } else if (userType === 'apartment') {
      this.roomService.getNewRoomOrderCount().subscribe(d => this.getNewRoomOrdersCount = d.data);
      this.roomService.getNewAdditionalOrderCount().subscribe(d => this.getAdditionalOrdersCount = d.data);
      if (this.apartmentType == 'residential') {
        this.apartmentService.getResidentialOrderCount().subscribe(d => this.getNewResidentialOrdersCount = d.data);
      }
    } else if (userType === 'restaurant') {
      this.food.getNewDeliveryCount().subscribe(d => this.getNewFoodOrdersCount = d.data);
    } else if (userType === 'RESIDENTIAL_ROOM_SERVICE') {
      this.apartmentService.getResidentialOrderCount().subscribe(d => this.getNewResidentialOrdersCount = d.data);
    } else if (userType === 'club') {
      this.club.getBookingCount().subscribe(d => this.getNewBookingsCount = d.data);
    }
    //  else {
    //   // ✅ Load all counts for admin/super user
    //   this.laundry.getNewDeliveryCount().subscribe(d => this.getNewOrdersCount = d.data);
    //   this.roomService.getNewRoomOrderCount().subscribe(d => this.getNewRoomOrdersCount = d.data);
    //   this.food.getNewDeliveryCount().subscribe(d => this.getNewFoodOrdersCount = d.data);
    //   this.roomService.getNewAdditionalOrderCount().subscribe(d => this.getAdditionalOrdersCount = d.data);
    // }
  }

  clearDatabase(): Promise<void> {
    return this.db.database
      .ref()
      .remove()
      .then(() => console.log('✅ Database cleared'))
      .catch((error) => console.error('❌ Error clearing database:', error));
  }

  isOnOrderPage(userType: string): boolean {
    const url = this.router.url;

    if (userType === 'laundry') {
      return this.deliveryActiveurl();
    } else if (userType === 'apartment' && this.apartmentType === 'residential') {
      return this.ResidentialOrderActiveurl();
    } else if (userType === 'apartment') {
      return this.RoomOrderActiveurl() || this.AdditionalOrderActiveurl();
    } else if (userType === 'restaurant') {
      return this.FoodorderActiveurl();
    } else if (userType === 'RESIDENTIAL_ROOM_SERVICE') {
      return this.ResidentialOrderActiveurl();
    } else if (userType === 'club') {
      return this.router.url.startsWith('/club/booking');
    }

    return false;
  }

  ResidentialOrderActiveurl(): boolean {
    return ['/resident-new-order', '/resident-accepted', '/resident-technician-assigned', '/resident-cancelled',
      '/resident-rejected', '/resident-in-progress', '/resident-work-in-progress', '/resident-delivery',
      '/resident-estimation']
      .some(path => this.router.url.includes(path));
  }

  setUserData() {
    const appName = `${environment.appName}`;
    this.role_id = localStorage.getItem(appName + 'role_id');
    this.username = localStorage.getItem('username');
    this.userType = localStorage.getItem('userType') || '';
    this.isStaff = localStorage.getItem('usertype') === 'subadmin';
    this.apartmentType = localStorage.getItem('apartment_type') || '';
    this.name = localStorage.getItem('name') || '';
    const data = localStorage.getItem('userData');
    if (data) {
      const user = JSON.parse(data);
      this.code = user.number || user?.code;
      this.isRoomServiceEnabled = user['room_service'] !== 0;
      this.isResidentialServiceEnabled = user['room_service'] !== 0;
    }
    this.apartmentName = this.name;
  }

  loadUserAccess() {
    const perms = localStorage.getItem('user_permissions');
    this.permissions = perms ? JSON.parse(perms) : [];
    this.userType = localStorage.getItem('userType') || '';
    this.isStaff = localStorage.getItem('usertype') === 'subadmin';
    this.apartmentType = localStorage.getItem('apartment_type') || '';
  }

  hasPermission(key: string): boolean {
    return this.permissions.includes(key);
  }

  playCustomSound() {
    const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
    const audioContext = new AudioContext();

    if (audioContext.state === 'suspended') {
      audioContext.resume();
    }

    fetch('/assets/images/new_order.mp3')
      .then(res => res.arrayBuffer())
      .then(buffer => audioContext.decodeAudioData(buffer))
      .then(decoded => {
        const source = audioContext.createBufferSource();
        source.buffer = decoded;
        source.connect(audioContext.destination);
        source.start();
      })
      .catch(err => console.error('🔇 Sound error:', err));
  }

  playCancelSound() {
    const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
    const audioContext = new AudioContext();

    if (audioContext.state === 'suspended') {
      audioContext.resume();
    }

    fetch('/assets/images/cancel_Order.mp3')
      .then(res => res.arrayBuffer())
      .then(buffer => audioContext.decodeAudioData(buffer))
      .then(decoded => {
        const source = audioContext.createBufferSource();
        source.buffer = decoded;
        source.connect(audioContext.destination);
        source.start();
      })
      .catch(err => console.error('🔇 Sound error:', err));
  }

  logout() {
    Swal.fire({
      title: 'Are You Sure You Want To Logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK'
    }).then((result) => {
      if (!result.isConfirmed) return;

      const fcmToken = localStorage.getItem('FCM_Token');

      if (fcmToken) {
        this.user.deleteFcm(fcmToken).subscribe({
          next: () => console.log('✅ FCM token deleted from backend'),
          error: err => console.error('❌ Delete FCM token failed', err)
        });
      }

      this.oneSignal.removeExternalUserId();
      this.oneSignal.deleteTag('user_type');

      this.auth.logout();
      localStorage.clear();
      sessionStorage.clear();

      this.router.navigate(['/login']);
    });
  }

  hasOwnerSession(): boolean {
    return !!localStorage.getItem('owner_original_token');
  }

  backToCollectiveDashboard(): void {
    const ownerToken = localStorage.getItem('owner_original_token');
    const ownerUser = localStorage.getItem('owner_original_userData');

    if (ownerToken) {
      localStorage.setItem(`${environment.appName}user`, ownerToken);
    }
    if (ownerUser) {
      localStorage.setItem('userData', ownerUser);
      try {
        const parsed = JSON.parse(ownerUser);
        localStorage.setItem('username', parsed.username || '');
        localStorage.setItem('name', parsed.name || '');
      } catch { }
    }
    localStorage.setItem('userType', 'owner');
    localStorage.setItem('type', 'owner');
    localStorage.removeItem('owner_original_token');
    localStorage.removeItem('owner_original_userData');

    this.router.navigate(['/collective-dashboard']).then(() => {
      window.location.reload();
    });
  }

  loadActiveStatus() {
    let apiCall: any;

    if (this.userType === 'apartment') {
      apiCall = this.user.getApartmentStatus();
    } else if (this.userType === 'laundry') {
      apiCall = this.user.getLaundryStatus();
    } else if (this.userType === 'restaurant') {
      apiCall = this.user.getRestaurantStatus();
    } else if (this.userType === 'club') {
      apiCall = this.club.getClubStatus();
    }

    if (!apiCall) return;

    apiCall.subscribe({
      next: (res: any) => {
        this.activestatus = Number(res.data.openStatus);
      },
      error: () => {
        this.activestatus = 0;
      }
    });
  }

  statuschange(e: any, type: string) {
    const newStatus = e.target.checked ? 1 : 0;
    this.blockstatus = newStatus === 1 ? 'Active' : 'Inactive';

    Swal.fire({
      title: `Are You Sure You Want To ${this.blockstatus} This ${type}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;

        let apiCall: any;
        if (type === 'apartment') apiCall = this.roomService.apartmentStatusChange(newStatus);
        else if (type === 'laundry') apiCall = this.laundry.laundryStatusChange(newStatus);
        else if (type === 'restaurant') apiCall = this.food.foodstatusChange(newStatus);
        else if (type === 'club') apiCall = this.club.clubstatusChange(newStatus);

        apiCall.subscribe({
          next: (data: any) => {
            this.loading = false;
            if (data.status.code == 200) {
              this.toastr.success(data.status.message);
              this.activestatus = newStatus;
            } else {
              this.toastr.error(data.status.message);
              e.target.checked = !e.target.checked;
            }
          },
          error: (error: any) => {
            this.loading = false;
            this.toastr.error(error.status?.message);
            e.target.checked = !e.target.checked;
          },
        });
      } else {
        e.target.checked = !e.target.checked;
      }
    });
  }

  // ── URL helpers ────────────────────────────────────────────────
  customerUrl() {
    return this.router.url.includes('/customer') ||
      this.router.url.includes('/add-customer') ||
      this.router.url.includes('/restaurant-details');
  }

  propertyUrl() {
    return this.router.url.includes('/apartment-properties') ||
      this.router.url.startsWith('/apartment-settings');
  }

  emergencyUrl() {
    const url = this.router.url;
    return url.startsWith('/emergency-notification') ||
      url.startsWith('/floor-mapping') ||
      url.startsWith('/active-alert') ||
      url.startsWith('/alert-history') ||
      url.startsWith('/alert-response') ||
      url.startsWith('/alert-report') ||
      url.startsWith('/saved-alert') ||
      (url.includes('/no-access') && url.includes('service=Emergency'));
  }

  RoomUrl() {
    return this.router.url.includes('/room-service') ||
      (this.router.url.includes('/no-access') && this.router.url.includes('Room%20Service'));
  }

  LaundryUrl() {
    return this.router.url === '/laundry' || this.router.url.startsWith('/laundry/');
  }

  RestaurantUrl() {
    return this.router.url.includes('/restaurants');
  }

  MenumanagementUrl() {
    return this.router.url.includes('/menu-management');
  }

  ResidentOrderActiveurl() {
    const isNoAccessForResident = this.router.url.includes('/no-access') && this.router.url.includes('Residential%20Order');
    return isNoAccessForResident || ['/resident-new-order', '/resident-accepted', '/resident-technician-assigned', '/resident-estimation',
      '/resident-in-progress', '/resident-work-in-progress', '/resident-rejected', '/resident-cancelled', '/resident-print-bill', '/resident-delivery']
      .some(path => this.router.url.includes(path));
  }

  RoomOrderActiveurl() {
    const isNoAccessForRoom = this.router.url.includes('/no-access') && this.router.url.includes('Room%20Order');
    return isNoAccessForRoom || ['/room-new-order', '/room-delivery-order', '/room-order-cancel',
      '/room-order-reject', '/room-accept-order', '/bill-to-desk', '/pickup']
      .some(path => this.router.url.includes(path));
  }

  AdditionalOrderActiveurl() {
    const isNoAccessForAdditional = this.router.url.includes('/no-access') && this.router.url.includes('Additional');
    return isNoAccessForAdditional || ['/additional-new-order', '/additional-order-accepted', '/additional-order-delivery',
      '/additional-order-cancelled', '/additional-order-rejected']
      .some(path => this.router.url.includes(path));
  }

  deliveryActiveurl() {
    return ['/new-order', '/order-delivery', '/order-cancel',
      '/order-reject', '/order-accepted', '/order-pickup', '/work-in-progress',
      '/assign-all', '/second-pickup']
      .some(path => this.router.url.includes(path));
  }

  StaffUrl() {
    return this.router.url.includes('/laundry-staff') ||
      this.router.url.includes('/add-laundry-staff');
  }

  ApartmentStaffUrl() {
    return this.router.url.includes('/apartment-staff') ||
      this.router.url.includes('/add-apartment-staff');
  }

  restaurantStaffUrl() {
    return this.router.url.includes('/restaurant-staff') ||
      this.router.url.includes('/add-restaurant-staff');
  }

  apartmentSettingsUrl() {
    return this.router.url == '/apartment-notification' ||
      this.router.url == '/reports-apartment' ||
      this.router.url == '/reports-residential' ||
      this.router.url.startsWith('/audit-logs') ||
      (this.router.url.includes('/no-access') && this.router.url.includes('Reports'));
  }

  FoodorderActiveurl() {
    return ['/food-new-order', '/food-order-delivery', '/food-order-cancel',
      '/food-order-reject', '/food-order-accepted', '/food-order-pickup',
      '/food-order-kanban']
      .some(path => this.router.url.includes(path));
  }

  private getNotifType(): 'ROOM_SERVICE' | 'RESIDENTIAL_ROOM_SERVICE' | 'RESTAURANT' | 'LAUNDRY' | 'CLUB' | null {
    if (this.userType === 'apartment' && this.apartmentType === 'residential') {
      return 'RESIDENTIAL_ROOM_SERVICE';
    }
    const map: Record<string, 'ROOM_SERVICE' | 'RESTAURANT' | 'LAUNDRY' | 'CLUB'> = {
      apartment: 'ROOM_SERVICE',
      restaurant: 'RESTAURANT',
      laundry: 'LAUNDRY',
      club: 'CLUB',
    };
    return map[this.userType] ?? null;
  }

  toggleNotifPanel() {
    this.showNotifPanel = !this.showNotifPanel;
    if (this.showNotifPanel) {
      this.checkSubscriptionStatus();
      this.resetAndLoad();
    }
  }

  resetAndLoad() {
    this.notifications = [];
    this.notifPage = 1;
    this.notifHasNext = false;
    this.loadNotifications();
  }

  loadNotifications() {
    const type = this.getNotifType();
    if (!type || this.notifLoading) return;

    this.notifLoading = true;

    this.user.getNotifications(type, this.notifPage).subscribe({
      next: (res) => {
        this.notifLoading = false;
        if (res?.status?.code === 200) {
          this.totalCount = res?.data?.totalDocs;
          this.notifications = [...this.notifications, ...(res.data?.docs ?? [])];
          this.notifHasNext = res.data?.hasNextPage ?? false;
        }
      },
      error: (err) => {
        this.notifLoading = false;
        console.error(' Failed to load notifications:', err);
      }
    });
  }

  onNotifScroll(event: Event) {
    const el = event.target as HTMLElement;
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 50;
    if (nearBottom && this.notifHasNext && !this.notifLoading) {
      this.notifPage++;
      this.loadNotifications();
    }
  }

  clearNotifications() {
    const type = this.getNotifType();
    if (!type) { this.notifications = []; return; }

    this.user.clearAllNotifications(type).subscribe({
      next: () => {
        this.notifications = [];
        this.notifPage = 1;
        this.notifHasNext = false;
      },
      error: (err) => {
        console.error(' Failed to clear notifications:', err);
        this.toastr.error('Could not clear notifications');
      }
    });
  }

  deleteOneNotification(id: string) {
    this.user.deleteNotification(id).subscribe({
      next: () => {
        this.notifications = this.notifications.filter(n => n._id !== id);
        this.loadNotifications()
      },
      error: (err) => {
        console.error(' Failed to delete notification:', err);
        this.toastr.error('Could not delete notification');
      }
    });
  }

  checkSubscriptionStatus() {
    const permission = ('Notification' in window) ? Notification.permission : 'denied';
    const fcmToken = localStorage.getItem('FCM_Token');
    this.isSubscribed = permission === 'granted' && !!fcmToken;
  }

  async toggleSubscription() {
    try {
      if (this.isSubscribed) {
        this.spinner.show();
        const fcmToken = localStorage.getItem('FCM_Token');
        if (fcmToken) {
          this.user.deleteFcm(fcmToken).subscribe({
            next: () => {
              console.log('✅ FCM token deleted from backend');
              localStorage.removeItem('FCM_Token');
              // Remembered across refreshes so app.component.ts's requestPermission()
              // doesn't silently re-request a token and re-subscribe the user.
              localStorage.setItem('notif_opted_out', '1');
              this.isSubscribed = false;
              this.spinner.hide();
            },
            error: (err) => {
              console.error('❌ Delete FCM token failed', err);
              this.spinner.hide();
            }
          });
        } else {
          localStorage.setItem('notif_opted_out', '1');
          this.isSubscribed = false;
          this.spinner.hide();
        }

      } else {
        this.spinner.show();
        localStorage.removeItem('notif_opted_out');
        this.afMessaging.requestToken.subscribe({
          next: (token) => {
            if (token) {
              localStorage.setItem('FCM_Token', token);
              const userId = localStorage.getItem('_restId');
              const userType = localStorage.getItem('type');
              if (userId && userType) {
                this.user.createFcm(userId, token, userType).subscribe({
                  next: () => {
                    console.log('✅ FCM token saved');
                    this.isSubscribed = true;
                    this.spinner.hide();
                  },
                  error: (err) => {
                    console.error('❌ FCM token save error:', err);
                    this.spinner.hide();
                  }
                });
              } else {
                this.isSubscribed = true;
                this.spinner.hide();
              }
            } else {
              this.spinner.hide();
            }
          },
          error: (err) => {
            console.error('❌ FCM token request error:', err);
            this.toastr.error('Could not enable notifications. Please allow notification permission in browser settings.');
            this.spinner.hide();
          }
        });
      }
    } catch (err) {
      console.error('Subscription toggle error:', err);
      this.spinner.hide();
    }
  }

  getTimeAgo(date: string | Date): string {
    const diff = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
    if (diff < 60) return 'Just now';   // ← no more "8s ago" vs "9s ago"
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
  }
}